var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1423.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#f7f3ef;}.cls-2,.cls-6,.cls-7,.cls-8{stroke:#070707;}.cls-11,.cls-14,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-14,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7{stroke-width:4px;}.cls-10,.cls-3,.cls-9{fill:#efaf00;}.cls-11,.cls-3,.cls-9{stroke:#000;}.cls-4{fill:#1c0e0c;}.cls-13,.cls-5{fill:#c48270;}.cls-14,.cls-5{stroke:#0f0f0f;}.cls-11,.cls-14,.cls-6{fill:none;}.cls-7,.cls-8{fill:#e57b07;}.cls-8,.cls-9{stroke-width:2px;}.cls-12{fill:#070707;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BACKGROUND",
    className: "cls-1",
    x: 10.08,
    y: 12.73,
    width: 1996.44,
    height: 1477.37
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Chars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COOK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1196.33,1417.49c0,12.23,9.13,16.7,9.12,38.39h-98s-1.67-22.38,22-23.07c20.34-.59,34.33-13.42,34.11-15.32S1196.33,1417.49,1196.33,1417.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1002.45,1417.49c0,12.23,9.13,16.7,9.12,38.39h-98s-1.67-22.38,22-23.07c20.34-.59,34.33-13.42,34.11-15.32S1002.45,1417.49,1002.45,1417.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "PANTS",
    className: "cls-2",
    d: "M997.75,867.2l191.52-.19c16,90.65-15.06,215.65-16.18,231-3.25,44.61,18.07,72.51,29,117.63,17.87,73.61,13.41,171.28.21,208.3l-51.87.35c-1.5-12.76-63-266-66-296.7l-18.09-86.26L1047.55,1119c-14.86,45.92-8.27,45.79-6.16,92.17,3.64,79.81-10.84,178.61-32.38,212.43l-58.84-.9c.09-138.4-5-272-3.29-298C947.28,1108.5,967.32,976.15,997.75,867.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SHADOW",
    className: "cls-2",
    d: "M1066.38,1041.33c-2.92-12.32-9.44-61.61-13.86-63.73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SHIRT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1199.23,934.05s-2.76-194.62-43.71-269.57c-23.83-43.62-113.67-62.7-125.79-63.48-15.9-1-44.1-.38-90.14,14.82-40.86,13.48-46.58,50.46-28.82,94.31S992.2,867,992.2,867c-2.6,19.77-14.2,70-14.2,70S1104,946.67,1199.23,934.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1046.2,604.08s3.48,33-37.58,56.19l-7.28-17.68L1024.81,599Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M926.26,621.56s13.2,46,51.74,49.14l-1.6-15.33-21.47-47.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1002.15,647,1013,673a12.56,12.56,0,0,1-12.11,15.9H961.69a12.8,12.8,0,0,0-11.75,17.89l82.44,182.44c1.93,4.19-3.68,50.21-3.68,50.21l65.18,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 976.64,
    cy: 721.12,
    r: 6.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1010.09,
    cy: 721.12,
    r: 6.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 993.58,
    cy: 764.07,
    r: 6.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1027.02,
    cy: 764.07,
    r: 6.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1011.56,
    cy: 807.62,
    r: 6.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1041.93,
    cy: 807.22,
    r: 6.07
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT_HAND",
    "data-name": "LEFT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND",
    className: "cls-3",
    d: "M926.26,621.56c-17,6.49-43.48,20.83-50.43,41.27s-24.48,76.36-24.48,76.36-29.06-27-34.54-35.39c0,0-1.49,16.83-36.25,17.56,0,0,19,132.73,90,135.9C898.61,858.52,927,820.78,931,753.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LINE",
    className: "cls-2",
    d: "M849.7,735.48c7.67,9.29,24.38,34.38,32.2,52.47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ARM"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M818.26,705.54s-19-33.84-34-40.92c-4.91-2.33-31,9.3-33.27,12s-7.86,24.11-7.86,24.11,8.78,2.35,12-4c3.75-7.32,10.2-14.89,18.72-12.52,4.9,1.36,15.21,13.57,10.75,16.52s-11.26-5.67-17.68-7.18-11.09,3.24-11.09,3.24,9.34,4.59,13.14,12.59c2.23,4.72,7.51,14,21.61,11.5C809,717.65,818.26,705.54,818.26,705.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M751,676.63s-9.62,8.52-20.41,13.09c0,0,3,8.46,14.85,2.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "CUFF",
    className: "cls-3",
    d: "M780.16,721s26-.36,38.1-15.43l10.14,11.73s-13.27,20.89-45.37,20Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SPICE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M759.75,713.27a2.13,2.13,0,1,0,1.35-2.7A2.13,2.13,0,0,0,759.75,713.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.65,734.81a1.71,1.71,0,1,0,1.09-2.16A1.72,1.72,0,0,0,738.65,734.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.49,778.88a2.13,2.13,0,1,0,1.35-2.69A2.13,2.13,0,0,0,746.49,778.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M764.24,784.37a2.34,2.34,0,1,0,1.49-3A2.34,2.34,0,0,0,764.24,784.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M753.15,818.24a2.35,2.35,0,1,0-.78-3.22A2.35,2.35,0,0,0,753.15,818.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.65,806.48a2.56,2.56,0,1,0-3.23-1.62A2.56,2.56,0,0,0,745.65,806.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.06,761.22a2.34,2.34,0,1,0,1.49-3A2.34,2.34,0,0,0,763.06,761.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M758.74,737.72A2.13,2.13,0,1,0,760.1,735,2.15,2.15,0,0,0,758.74,737.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.59,744.68a2.2,2.2,0,1,0,1.4-2.77A2.21,2.21,0,0,0,749.59,744.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M751.48,730.41a2.19,2.19,0,1,0,1.39-2.77A2.18,2.18,0,0,0,751.48,730.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.18,758.31a2.2,2.2,0,1,0,1.4-2.77A2.21,2.21,0,0,0,746.18,758.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.19,797.51a2.2,2.2,0,1,0,1.39-2.77A2.2,2.2,0,0,0,755.19,797.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745,841a2.19,2.19,0,1,0,1.4-2.77A2.2,2.2,0,0,0,745,841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M761,822.81a2.2,2.2,0,1,0,1.4-2.78A2.21,2.21,0,0,0,761,822.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 734.19,
    cy: 822.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.36,822.44a2.2,2.2,0,1,0,1.39-2.78A2.19,2.19,0,0,0,776.36,822.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.37,769.13a2.2,2.2,0,1,0,1.39-2.78A2.19,2.19,0,0,0,755.37,769.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.3,786.83a2.2,2.2,0,1,0,1.4-2.77A2.2,2.2,0,0,0,735.3,786.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M771.52,791a2.2,2.2,0,1,0,1.39-2.78A2.19,2.19,0,0,0,771.52,791Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755,706.55a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,755,706.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.67,751.21a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,760.67,751.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M760.67,751.21a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,760.67,751.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762.27,773.66a1.46,1.46,0,1,0,.93-1.85A1.45,1.45,0,0,0,762.27,773.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 741.81,
    cy: 764.04,
    r: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.05,774.86A1.46,1.46,0,1,0,739,773,1.45,1.45,0,0,0,738.05,774.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M762,810.84a1.46,1.46,0,0,0,1.85.93A1.46,1.46,0,1,0,763,809,1.46,1.46,0,0,0,762,810.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.6,805.79a1.46,1.46,0,1,0,.93-1.85A1.47,1.47,0,0,0,775.6,805.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M743.12,825.64a1.46,1.46,0,1,0,.93-1.85A1.48,1.48,0,0,0,743.12,825.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 757.88,
    cy: 831.31,
    r: 1.46,
    transform: "translate(-178.36 1454.94) rotate(-81.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M732.2,810.92A1.46,1.46,0,1,0,735,810a1.46,1.46,0,0,0-2.78.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M781.48,813.76a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,781.48,813.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M768.18,829.44a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,768.18,829.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 765.03,
    cy: 845.51,
    r: 1.46,
    transform: "translate(-186.33 1474.07) rotate(-81.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.21,836.91A1.46,1.46,0,1,0,780,836a1.46,1.46,0,1,0-2.77.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.52,835.63a1.46,1.46,0,1,0,.93-1.85A1.47,1.47,0,0,0,738.52,835.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M726.61,843.92a1.48,1.48,0,0,0,1.85.93,1.46,1.46,0,1,0-1.85-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M741.92,858.91a1.46,1.46,0,1,0,.93-1.84A1.45,1.45,0,0,0,741.92,858.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M744.09,788.47a1.46,1.46,0,1,0,.93-1.85A1.47,1.47,0,0,0,744.09,788.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 765.31,
    cy: 804.47,
    r: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M758.79,789.41a1.46,1.46,0,1,0,.93-1.85A1.46,1.46,0,0,0,758.79,789.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HEAD-2",
    "data-name": "HEAD",
    className: "cls-5",
    d: "M933.38,588.39c-1-1.16-1.24,23.46,2.67,41.22,7.18,32.58,30.27,39.64,34.74,40,25.87,1.9,44.4-25.67,44.5-34.64s-.12-15.62-.12-15.62,17.76-10.21,9.2-20.39C1018.92,592.44,981.39,576.75,933.38,588.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CAP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M933.38,588.39l-5.54-24S969.4,544.84,1028,576l-3.59,23S986.88,576.78,933.38,588.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M910.12,549.13c5.41,10.4,15,16.53,17.72,15.28,14.87-6.72,36-6.17,43.15-5.74,27.64,30.55,96.49,76.59,91.31,16-5.22-61-113.82-96.11-145.89-70.55C910.49,508.79,897.22,524.29,910.12,549.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1052.82,604.13c-27,1.66-60.76-24.12-80.28-44.32l0,0-.45-.41C957.64,545.8,940,512,905.57,525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M974.46,585.37s-25.23,22.87-44.39,14.26c-21.35-9.59-3.17-24.74,1.9-17.37C938.72,592.08,951.52,582.06,974.46,585.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M991.78,587.69s9.7,1,12.73,12.94,9.33,5.59,9.33,5.59.53-12.07,3.61-10.68A82,82,0,0,0,991.78,587.69Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 247.57,
    y: 1012.54,
    width: 982.18,
    height: 452.07
  }), /*#__PURE__*/React.createElement("g", {
    id: "KITCHEN_STOVE",
    "data-name": "KITCHEN STOVE"
  }, /*#__PURE__*/React.createElement("line", {
    id: "FLOOR",
    className: "cls-2",
    x1: 1827.43,
    y1: 1070.96,
    x2: 1199.23,
    y2: 1070.96
  }), /*#__PURE__*/React.createElement("g", {
    id: "TILE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1312.57 415.01 1312.57 489.13 1248.39 489.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1376.75 415.01 1376.75 489.13 1312.57 489.13 1312.57 415.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1248.39 563.25 1312.57 563.25 1312.57 489.13 1248.39 489.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.57,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1440.93 415.01 1440.93 489.13 1376.75 489.13 1376.75 415.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1505.11 415.01 1505.11 489.13 1440.93 489.13 1440.93 415.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1376.75,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1440.93,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1248.39 563.25 1312.57 563.25 1312.57 637.37 1248.39 637.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.57,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1248.39 637.37 1312.57 637.37 1312.57 711.49 1248.39 711.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1312.57,
    y: 637.37,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1376.75,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1440.93,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1376.75,
    y: 637.37,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1440.93,
    y: 637.37,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1569.29 415.01 1569.29 489.13 1505.11 489.13 1505.11 415.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1569.29 415.01 1569.29 489.13 1633.46 489.13 1633.46 415.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1505.11,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1569.28,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1697.64 415.01 1697.64 489.13 1633.46 489.13 1633.46 415.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1761.82 489.13 1697.64 489.13 1697.64 563.25 1761.82 563.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1761.82 489.13 1697.64 489.13 1697.64 415.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1633.46,
    y: 489.13,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1505.11,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1569.28,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1505.11,
    y: 637.37,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1569.28,
    y: 637.37,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1633.46,
    y: 563.25,
    width: 64.18,
    height: 74.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1761.82 637.37 1697.64 637.37 1697.64 711.49 1761.82 711.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1761.82 637.37 1697.64 637.37 1697.64 563.25 1761.82 563.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1633.46,
    y: 637.37,
    width: 64.18,
    height: 74.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "POT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1432.81,594.95h119.45a0,0,0,0,1,0,0v88.32A16.73,16.73,0,0,1,1535.53,700h-86a16.73,16.73,0,0,1-16.73-16.73V594.95A0,0,0,0,1,1432.81,594.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1552.26,603.68h13.93l15-9.32a2.31,2.31,0,0,0,.75-2.66h0a2.77,2.77,0,0,0-4.24-1l-13.44,8.08h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1432.8,603.68h-13.93l-15-9.32a2.3,2.3,0,0,1-.75-2.66h0a2.77,2.77,0,0,1,4.24-1l13.44,8.08h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1552.26,594.79H1432.81c5.79-8.18,30.33-14.32,59.72-14.32S1546.47,586.61,1552.26,594.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1502.34,569.79H1484a2.34,2.34,0,0,0-2.34,3.16l3.25,7.55h16.5l3.24-7.55A2.34,2.34,0,0,0,1502.34,569.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FRYING_PAN",
    "data-name": "FRYING PAN"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1367.35,700h-67.69c-11.06,0-21-7.33-24.83-18.39l-4.49-12.82h126.32l-4.49,12.82C1388.3,692.66,1378.41,700,1367.35,700Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1266.31,
    y: 663.62,
    width: 134.38,
    height: 5.16,
    rx: 2.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1441.31 673.16 1395.22 673.16 1396.78 668.77 1441.31 668.77 1441.31 673.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1440.53,
    y: 665.81,
    width: 51.56,
    height: 9.3,
    rx: 4.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1616,426.09c-110.37,2.79-152.74,58.83-128,114.78,43.71,98.94-129.61,78.83-148.51,98.79-15.66,16.54,19.22,24.12,19.22,24.12H1326.5s-53.85-20.47-31-57.89,88.45-31.15,88.45-69.5-119.83-51.92-86.6-110.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "STOVE_HOOD",
    "data-name": "STOVE HOOD"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1231.51,
    y: 388.79,
    width: 549.14,
    height: 36.9,
    rx: 6.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1713.87 388.44 1298.29 388.44 1437.92 273.04 1574.24 273.04 1713.87 388.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1438.42,
    y: 193.69,
    width: 135.33,
    height: 79.34
  })), /*#__PURE__*/React.createElement("g", {
    id: "NOTES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1681.12,466.29h-48a10.73,10.73,0,0,1-10.73-10.73V405.12h48v50.44A10.73,10.73,0,0,0,1681.12,466.29Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1672.59,
    y1: 412.97,
    x2: 1663.91,
    y2: 403.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1620.62,
    y1: 412.97,
    x2: 1629.3,
    y2: 403.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1636.94,
    y1: 421.05,
    x2: 1657.32,
    y2: 421.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1636.94,
    y1: 431.36,
    x2: 1657.32,
    y2: 431.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1636.94,
    y1: 441.67,
    x2: 1657.32,
    y2: 441.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1636.94,
    y1: 451.98,
    x2: 1657.32,
    y2: 451.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1687.5,
    y: 412.16,
    width: 34.98,
    height: 35.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1701.8,
    y: 408.46,
    width: 6.23,
    height: 6.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "COOKER"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1229.75,
    y: 711.49,
    width: 550.84,
    height: 320.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1229.75,
    y: 736.71,
    width: 550.84,
    height: 62.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1595.59,
    y: 799.58,
    width: 185.06,
    height: 232.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1614.67,
    y: 811.6,
    width: 147.29,
    height: 187.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1249.34,
    y: 811.6,
    width: 323.58,
    height: 187.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1780.6 1070.96 1762.39 1070.96 1761.96 1032.08 1780.6 1032.08 1780.6 1070.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1229.75 1070.96 1247.95 1070.96 1248.39 1032.08 1229.75 1032.08 1229.75 1070.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1576.7,
    y: 1032.08,
    width: 18.64,
    height: 38.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1755.65 816.59 1755.65 865.84 1620.77 970.22 1620.77 816.59 1755.65 816.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1755.65 894.51 1755.65 920.27 1666.29 992.95 1625.86 992.95 1755.65 894.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1632.06,
    y: 822.71,
    width: 112.51,
    height: 11.63,
    rx: 4.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1667.13,
    cy: 767.83,
    r: 10.8,
    transform: "translate(640.57 2289.37) rotate(-80.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1701.35,
    cy: 767.83,
    r: 10.8,
    transform: "translate(560.06 2244.86) rotate(-76.6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1667.13,
    y1: 767.83,
    x2: 1667.13,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1701.35,
    y1: 767.83,
    x2: 1701.35,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1300.36,
    cy: 767.83,
    r: 10.8,
    transform: "translate(-162.07 1144.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1334.58,
    cy: 767.83,
    r: 10.8,
    transform: "translate(-152.05 1168.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1392.59,
    cy: 767.83,
    r: 10.8,
    transform: "translate(322.87 1944.51) rotate(-76.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1426.81,
    cy: 767.83,
    r: 10.8,
    transform: "translate(-125.04 1233.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1484.82,
    cy: 767.83,
    r: 10.8,
    transform: "translate(393.72 2034.23) rotate(-76.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1519.04,
    cy: 767.83,
    r: 10.8,
    transform: "translate(420.01 2067.52) rotate(-76.6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1484.82,
    y1: 767.83,
    x2: 1493,
    y2: 774.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1519.04,
    y1: 767.83,
    x2: 1519.04,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1300.36,
    y1: 767.83,
    x2: 1309.9,
    y2: 762.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1334.58,
    y1: 767.83,
    x2: 1334.58,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1392.59,
    y1: 767.83,
    x2: 1392.59,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1426.81,
    y1: 767.83,
    x2: 1426.81,
    y2: 757.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1488.26 816.59 1255.06 986.23 1255.06 816.59 1488.26 816.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1519.55 816.59 1562.26 816.59 1312.38 991.71 1269.67 991.71 1519.55 816.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1263.5,
    y: 822.71,
    width: 291.83,
    height: 11.63,
    rx: 3.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1454.51 711.49 1466.31 702.09 1522.57 702.09 1534.37 711.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1494.44,
    y1: 702.09,
    x2: 1494.44,
    y2: 711.49
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1646.95 711.49 1658.75 702.09 1715.01 702.09 1726.81 711.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1686.88,
    y1: 702.09,
    x2: 1686.88,
    y2: 711.49
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1292.76 711.49 1304.57 702.09 1360.82 702.09 1372.63 711.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1332.69,
    y1: 702.09,
    x2: 1332.69,
    y2: 711.49
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1361.72,
    y: 895.02,
    width: 31.39,
    height: 265.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1361.71 1160.71 1361.71 895.02 1393.11 895.02 1393.11 1160.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.55 996.1 1229.78 996.1 1414.57 868.32 385.39 868.32 209.55 996.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "209.55 996.1 1229.78 996.1 1414.57 868.32 385.39 868.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.7 996.1 1229.89 996.1 1414.67 868.32 1414.67 884.55 1229.89 1012.34 209.66 1012.34 209.7 996.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "209.7 996.1 1229.89 996.1 1414.67 868.32 1414.67 884.55 1229.89 1012.34 209.66 1012.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "247.57 1218.68 247.57 1012.54 1199.23 1012.54 1199.23 1218.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1199.23 1012.54 1199.23 1028.43 247.57 1121.27 247.57 1012.54 1199.23 1012.54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GLASS_OF_WINE",
    "data-name": "GLASS OF WINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.38,858.8h0a8.77,8.77,0,0,0-8.78,8.77V902.4a9.89,9.89,0,0,0,6.78,9.39l9,3a.66.66,0,0,1-.21,1.29H492a.66.66,0,0,1-.21-1.29l9-3a9.9,9.9,0,0,0,6.77-9.39V867.57a8.77,8.77,0,0,0-8.77-8.77h20.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518,854.93H500.18a9.42,9.42,0,0,1-9.37-10.29l1.2-12.76h34.15l1.2,12.76A9.42,9.42,0,0,1,518,854.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520,858.8H498.16a11.56,11.56,0,0,1-11.51-12.63l4.4-47.11h36.07l4.4,47.11A11.56,11.56,0,0,1,520,858.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M576.56,752.46h0a29.06,29.06,0,0,1,29.06,29.06V904.25a11.82,11.82,0,0,1-11.82,11.82H559.32a11.82,11.82,0,0,1-11.82-11.82V781.52a29.06,29.06,0,0,1,29.06-29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M605.61,781.52V904.25a11.82,11.82,0,0,1-11.82,11.82H559.32a11.82,11.82,0,0,1-11.82-11.82V781.52a29.07,29.07,0,0,1,20.38-27.74V711.71a4.29,4.29,0,0,1,4.29-4.28H581a4.28,4.28,0,0,1,4.28,4.28v42.07a29.07,29.07,0,0,1,20.38,27.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M551.84,901.3V781.68h49.43V901.3a9.58,9.58,0,0,1-9.36,9.78H561.2A9.58,9.58,0,0,1,551.84,901.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M605.61,781.52V904.25a11.8,11.8,0,0,1-4.05,8.91,6.13,6.13,0,0,1-9.62-2.28l-1-2.29a15.67,15.67,0,0,0-14.39-9.46h0a15.68,15.68,0,0,0-14.4,9.46l-1,2.29a6.13,6.13,0,0,1-9.62,2.28,11.78,11.78,0,0,1-4-8.91V781.52a29.07,29.07,0,0,1,20.38-27.74V711.71a4.29,4.29,0,0,1,4.29-4.28H581a4.28,4.28,0,0,1,4.28,4.28v42.07a29.1,29.1,0,0,1,20.38,27.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 559.76,
    y: 801.67,
    width: 33.6,
    height: 62.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.7,706.51h9.72a4.73,4.73,0,0,1,4.73,4.73v14.11a0,0,0,0,1,0,0H567a0,0,0,0,1,0,0V711.23A4.73,4.73,0,0,1,571.7,706.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PEPPER_SHAKER",
    "data-name": "PEPPER SHAKER"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650.57,786.56h0A11.76,11.76,0,0,1,638.8,774.8h0A11.77,11.77,0,0,1,650.57,763h0a11.76,11.76,0,0,1,11.76,11.77h0A11.75,11.75,0,0,1,650.57,786.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M651.08,784.5h-2.57a11.77,11.77,0,0,1-11.77-11.76h0A11.77,11.77,0,0,1,648.51,761h2.57a11.77,11.77,0,0,1,11.77,11.77h0A11.77,11.77,0,0,1,651.08,784.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M657.74,865.07H641.85c-5.48,0-9.74-7.34-9.14-12.78l1.63-14.82c1.6-14.46,3.78-26.49,1.4-40.84h0a8.22,8.22,0,0,1,8.11-9.55h11.9a8.21,8.21,0,0,1,8.1,9.55v.1c-2.37,14.34-.18,26.36,1.41,40.8l1.63,14.76C667.48,857.73,663.22,865.07,657.74,865.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M657.74,865.07H641.85c-5.48,0-9.74-7.34-9.14-12.78l1.63-14.82c1.6-14.46,3.78-26.49,1.4-40.84h0a8.22,8.22,0,0,1,8.11-9.55h11.9a8.21,8.21,0,0,1,8.1,9.55v.1c-2.37,14.34-.18,26.36,1.41,40.8l1.63,14.76C667.48,857.73,663.22,865.07,657.74,865.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 633.3,
    y: 863.52,
    width: 32.99,
    height: 5.01,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662.42,787.65H637.17a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h25.25a2.19,2.19,0,0,1,2.19,2.19h0A2.19,2.19,0,0,1,662.42,787.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664,887.06H638.23a2.76,2.76,0,0,1-2.73-3.15l1.56-10.71a2.75,2.75,0,0,1,2.72-2.36h22.68a2.75,2.75,0,0,1,2.72,2.36l1.55,10.71A2.75,2.75,0,0,1,664,887.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.93,886.3H635.66a3,3,0,0,1-3-3.45l1.7-11.74a3,3,0,0,1,3-2.59h24.87a3,3,0,0,1,3,2.59l1.7,11.74A3,3,0,0,1,663.93,886.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.36,858.37a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,642.36,858.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 647.8,
    cy: 848.06,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.14,837.51a2.56,2.56,0,1,1-2.55-2.56A2.55,2.55,0,0,1,659.14,837.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M655.93,828.09a2.55,2.55,0,1,1-2.55-2.56A2.55,2.55,0,0,1,655.93,828.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.59,839a2.56,2.56,0,1,1-2.55-2.55A2.56,2.56,0,0,1,641.59,839Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 644.16,
    cy: 834.27,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M655.25,852.7a2.56,2.56,0,1,1-2.56-2.55A2.56,2.56,0,0,1,655.25,852.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 662.49,
    cy: 855.54,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.51,854.51A2.55,2.55,0,1,1,645,852,2.55,2.55,0,0,1,647.51,854.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 641.87,
    cy: 844.71,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.63,858.89a2.56,2.56,0,1,1-2.55-2.55A2.55,2.55,0,0,1,659.63,858.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.21,843.17a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,663.21,843.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 650.83,
    cy: 834.53,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.07,850.9a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,641.07,850.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 650.37,
    cy: 858.89,
    r: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.79,845a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,656.79,845Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662.2,830.5a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,662.2,830.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650.37,841.34a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,650.37,841.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M661.69,850.12a2.55,2.55,0,1,1-2.55-2.55A2.56,2.56,0,0,1,661.69,850.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ONION"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1212.16,898.15l-.34-4.69c.63,0,63.85-4.87,128.1-35l2,4.26C1276.85,893.23,1212.8,898.1,1212.16,898.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1217,904.79l-1.46-4.47c46.77-15.29,113.38-9,114-9l-.46,4.68C1328.47,896,1262.81,889.81,1217,904.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1218.9,902.16l-1.52-4.45c39.64-13.58,79.19-16.91,105.4-17.32,28.39-.43,47.72,2.39,47.91,2.42l-.69,4.65c-.19,0-19.22-2.8-47.26-2.36C1296.91,885.5,1257.92,888.78,1218.9,902.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1207.17,893.45s10.42-.57,26.34-2.89c2.56-.37,2.84,9.46,2.84,9.46s-23.13,6-28.7,6.66C1203.73,907.18,1207.17,893.45,1207.17,893.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1207.18,
    cy: 900.14,
    rx: 4.86,
    ry: 6.69,
    transform: "translate(-1.21 1.63) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1207,905.35c-2-.15-3.68-2.42-3.69-5.18a6.22,6.22,0,0,1,1.09-3.61,3.47,3.47,0,0,1,2.8-1.58c2.14,0,3.9,2.32,3.91,5.18h0a6.25,6.25,0,0,1-1.09,3.62,3.48,3.48,0,0,1-2.8,1.57Zm.36-9.42h-.16a2.59,2.59,0,0,0-2,1.19,5.22,5.22,0,0,0-.91,3.06c0,2.34,1.33,4.23,3,4.24a2.56,2.56,0,0,0,2-1.19,5.2,5.2,0,0,0,.91-3.06C1210.13,897.9,1208.89,896,1207.33,895.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1207.06,902.67a2.3,2.3,0,0,1-1.84-2.51,2.27,2.27,0,0,1,2-2.52c1.11,0,2,1.1,2,2.51h0c0,1.42-.86,2.53-2,2.53Zm.17-4.09h0c-.55,0-1,.72-1,1.58s.49,1.58,1,1.58,1-.73,1-1.58S1207.76,898.62,1207.23,898.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1189.59,917l-.9-4.61c60.84-12,165.81-6.1,166.87-6l-.27,4.69C1354.24,911,1249.86,905.12,1189.59,917Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1188.3,925.27l-1.44-4.47c20.46-6.63,57.46-13.66,117.58-9.49a572.62,572.62,0,0,1,63.68,7.94l-.91,4.61a564.16,564.16,0,0,0-63.16-7.86C1271.3,913.73,1224.64,913.5,1188.3,925.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1188.56,913.63l.06-4.7c.24,0,24.31.25,58.15-5.34,31.18-5.15,77.28-16.46,119.81-41.07l2.36,4.07c-43.19,25-89.92,36.44-121.51,41.66C1213.2,913.89,1188.8,913.63,1188.56,913.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1191.65,
    y: 902.2,
    width: 190.17,
    height: 4.7,
    transform: "translate(-115.12 191.31) rotate(-8.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1188.76,908.93s19.61-.33,40.33-2.87c0,0,5.75,4.8,1.69,10.75a254.71,254.71,0,0,0-42.43,8.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1192.82,917.65c-.42,4.58-2.93,8.09-5.61,7.84s-4.51-4.15-4.1-8.73,2.93-8.08,5.61-7.83S1193.24,913.08,1192.82,917.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1187.43,923.8h0a3.4,3.4,0,0,1-2.65-2.21,8.84,8.84,0,0,1-.67-4.47c.32-3.52,2.26-6.13,4.43-6h0a3.4,3.4,0,0,1,2.65,2.21,8.84,8.84,0,0,1,.67,4.47C1191.54,921.35,1189.6,924,1187.43,923.8Zm1-11.71c-1.6-.12-3.17,2.21-3.43,5.11a7.84,7.84,0,0,0,.58,4,2.52,2.52,0,0,0,1.89,1.67h0c1.59.12,3.16-2.21,3.42-5.11a7.84,7.84,0,0,0-.58-4,2.52,2.52,0,0,0-1.89-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1187.71,920.37h0c-1.11-.1-1.85-1.51-1.69-3.21s1.12-2.93,2.22-2.84h0c1.1.1,1.85,1.51,1.69,3.2h0C1189.78,919.21,1188.81,920.45,1187.71,920.37Zm.44-5.12c-.49,0-1.11.81-1.22,2s.36,2.14.84,2.18h0c.49,0,1.11-.81,1.22-2h0c.11-1.2-.36-2.14-.84-2.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DISH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DISH-2",
    "data-name": "DISH",
    className: "cls-2",
    d: "M918.21,892.6c0,2.15-13.91,4.11-36.42,5.53-22.72,1.43-54.2,2.32-89,2.32s-66.27-.89-89-2.32c-22.51-1.42-36.42-3.38-36.42-5.53,0-4.33,56.15-7.85,125.41-7.85S918.21,888.27,918.21,892.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "GREEN",
    className: "cls-2",
    d: "M808.17,873s9.08-20.21-8.57-18.86c-6.46.49-9.19,9.34-12.45,4.74s.59-13.44-14.81-11.37c-19.47,2.62-9.82,17-9.82,17s-2.53,7.54-10.86-4-22.55-1.33-19.51,7.84c2.17,6.49-17.69-1.22-14.77,13.76s20.91,8,29.42,7.2c7.37-.66,41.55-3.85,41.55-3.85S790.61,875.09,808.17,873Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LEMON"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M800.65,872.1a1.13,1.13,0,0,1-1.23-1.05c-.9-10.88,6.37-19.28,16.19-20.62s18.6,4.86,20.62,15.58a1.13,1.13,0,0,1-.91,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M800.53,872.12c-1.41-10.31,6-17.8,15.62-19.12s17.89,4,19.3,14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M813.18,859a.77.77,0,0,1,.44-1.08,19.27,19.27,0,0,1,2.68-.55,18,18,0,0,1,2.72-.18.76.76,0,0,1,.71.92l-1.56,8.41a.7.7,0,0,1-1.34.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M803.71,870.83a13.14,13.14,0,0,1,.36-3.72.69.69,0,0,1,.89-.52l7.35,2.44a.78.78,0,0,1-.1,1.49l-7.68,1.05A.75.75,0,0,1,803.71,870.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M822.75,867.59l6.94-4.42a.71.71,0,0,1,1,.27A13,13,0,0,1,832,867a.75.75,0,0,1-.59.94L823.23,869A.78.78,0,0,1,822.75,867.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M805.58,863.58a12.84,12.84,0,0,1,4.7-4.27.7.7,0,0,1,1,.3l4.26,7.64a.74.74,0,0,1-.86,1.1l-8.71-3.62A.8.8,0,0,1,805.58,863.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M819.8,866.29l2.25-8.08a.71.71,0,0,1,.85-.52,12.67,12.67,0,0,1,5.49,2.88.79.79,0,0,1-.06,1.21l-7.43,5.37A.74.74,0,0,1,819.8,866.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FISH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M856.9,898.07s1.13-30.85-28.09-33.78c-28.68-2.88-39.22,23.88-55,18.27-13.37-4.76-38.65.83-42,15.51C731.88,898.07,837.27,901.15,856.9,898.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M740.56,897.36s8.51-16.4,30.77-8.36c27.31,9.86,24.41-21.43,56.53-17,20.53,2.8,23,25.41,23,25.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M748.14,897.36s3.63-4.66,13.26-4.66,14.17,5.77,14.17,5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M816.65,899.25s.16-8.44,8.37-8.44a10,10,0,0,1,9.94,7.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805.13,899.25s7-14.44,20-14.44,14.36,13.26,14.36,13.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.67,898.47s16.81.84,23.43-6.84c7.26-8.4,8.47-13.6,24.89-13.41,17.42.21,21.08,19.5,21.08,19.5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "GREEN-2",
    "data-name": "GREEN",
    className: "cls-2",
    d: "M802.64,907s-2.29-12.44,3.31-16.08,11.25.87,10.71,4.7,14-7.28,17.87-8.82c5.12-2,12.41-2.88,11.71,8.37S802.64,907,802.64,907Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LEMON-2",
    "data-name": "LEMON"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M869.27,873.13a1.22,1.22,0,0,1,1.65.61c5.16,10.75,1.15,22.06-8.16,27.14S842.22,903,836,892.78a1.22,1.22,0,0,1,.38-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M869.39,873.07c5.45,10,1.79,19.46-7.36,24.45s-20.31,3.59-25.76-6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M861.83,891.19a.84.84,0,0,1,0,1.26,20,20,0,0,1-2.47,1.58,19.57,19.57,0,0,1-2.65,1.21.84.84,0,0,1-1.08-.67l-1.72-9.16a.74.74,0,0,1,1.27-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M866.71,875.58a15,15,0,0,1,1.1,3.93.74.74,0,0,1-.7.87l-8.31.28a.84.84,0,0,1-.48-1.55l7.28-4A.81.81,0,0,1,866.71,875.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M848.89,886.07l-5.22,7.13a.75.75,0,0,1-1.1.1,14.85,14.85,0,0,1-2.73-3.07.81.81,0,0,1,.23-1.17l7.79-4.25A.85.85,0,0,1,848.89,886.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M867.67,883.68a13.6,13.6,0,0,1-3,6.13.74.74,0,0,1-1.07.06l-7.26-6.19a.8.8,0,0,1,.44-1.44l10.14.4A.89.89,0,0,1,867.67,883.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M852.36,886.29l.9,9.09a.74.74,0,0,1-.65.84,13.46,13.46,0,0,1-6.62-.85.89.89,0,0,1-.42-1.26l5.35-8.29A.8.8,0,0,1,852.36,886.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.29,898.81a1.14,1.14,0,0,1,.27,1.65c-6.64,8.66-18.15,9.69-26.92,3.72S711,887.4,716.7,878.07a1.16,1.16,0,0,1,1.64-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M749.4,898.88c-5.85,8.6-16.84,8.89-25.45,3s-11.58-15.65-5.72-24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M730.41,899.56a.76.76,0,0,1-1.08.48,22.49,22.49,0,0,1-2.52-1.49,23.08,23.08,0,0,1-2.3-1.79.77.77,0,0,1,.06-1.19l6.94-5.09a.76.76,0,0,1,1.19.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M746,897.58a12.53,12.53,0,0,1-2.8,2.49.77.77,0,0,1-1.07-.25l-4.22-7a.77.77,0,0,1,1.09-1l6.85,4.67A.77.77,0,0,1,746,897.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M728.56,886.46,720,884.8a.78.78,0,0,1-.61-.9,12.6,12.6,0,0,1,1.29-3.55.78.78,0,0,1,1.11-.27l7.33,5A.76.76,0,0,1,728.56,886.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M739.58,901.59a13.71,13.71,0,0,1-6.66-.18.78.78,0,0,1-.57-.9l1.77-8.66a.77.77,0,0,1,1.44-.19l4.52,8.84A.76.76,0,0,1,739.58,901.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M730,889.51l-7.28,4.37a.77.77,0,0,1-1-.23,13.52,13.52,0,0,1-2.45-6,.77.77,0,0,1,.87-.85l9.59,1.31A.76.76,0,0,1,730,889.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "DISH-3",
    "data-name": "DISH",
    className: "cls-2",
    d: "M885.06,898.13l-18.22,15.2a24.36,24.36,0,0,1-15.61,5.56H733.11a24.39,24.39,0,0,1-15.62-5.56l-18.21-15.2h4.54c22.72,1.43,54.2,2.32,89,2.32s66.26-.89,89-2.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MUSHROOMS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1169.88,960.65l-.26,0-11.85-3.52-.81-.1,1.16-6.13,12,1.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1169.77 965.86 1155.56 964.37 1158.11 950.87 1170.07 952.13 1169.77 965.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1166.42,955l-5.33-.56c-6.71-.7-11.81-4.46-11.1-11.16h0c.7-6.71,9-11.34,15.67-10.64l.83.09c6.7.71,13.82,6.95,13.12,13.66h0C1178.9,953.07,1173.13,955.68,1166.42,955Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1062.14,924.64l-2.36,1.59a17.87,17.87,0,0,0-6.34,8c-1.22,3.14-1.34,6.41.3,8.82,2.72,4,7.36,4.15,12,1.92l2.32,4.91a1.85,1.85,0,0,0,2.77.51l8-5.44a1.85,1.85,0,0,0,.56-2.76l-3.72-4a13.51,13.51,0,0,0,3.34-4.53,7.35,7.35,0,0,0-.59-7.23C1075.24,921.57,1067.78,920.8,1062.14,924.64Zm3.65,20.38c-2.89.93-5.45.44-6.38-.94-1.05-1.54.2-3.93,2.63-6.54Zm9.93-6.75-5.57-6.24c3.32-1.3,6-1.58,7,0C1078.14,933.37,1077.65,935.93,1075.72,938.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1164.34,912l-1.45-1.62a13.64,13.64,0,0,0-6.77-4c-2.52-.61-5-.36-6.68,1.13-2.76,2.48-2.39,6-.21,9.36l-3.51,2.26a1.43,1.43,0,0,0-.09,2.16l4.95,5.53a1.43,1.43,0,0,0,2.16.14l2.63-3.24a10.35,10.35,0,0,0,3.79,2.08,5.64,5.64,0,0,0,5.44-1.2C1168,921.69,1167.84,915.94,1164.34,912Zm-15.11,4.88c-1-2.11-.9-4.1,0-4.95s3-.25,5.24,1.33Zm6.14,6.85,4.17-4.87c1.33,2.39,1.82,4.41.76,5.36S1157.35,925,1155.37,923.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1133,931.22l-.91.19-11.45,1.09-1,.15-1.16-6,11.58-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1132.12,937.08l-8.13,2.29a2.7,2.7,0,0,1-3.37-2.08l-2.06-10.62,11.58-3.25,3.77,10.14A2.68,2.68,0,0,1,1132.12,937.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1127.8,927.41l-5.16,1.45c-6.49,1.82-12.62.22-14.44-6.28h0c-1.83-6.49,4.14-13.84,10.63-15.67l.8-.22c6.5-1.82,15.42,1.35,17.24,7.85h0C1138.69,921,1134.29,925.59,1127.8,927.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1098.58,951.51l-.7-.33-8-5c-.24-.12-.48-.25-.7-.38l2.24-4.5,9.22,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1095,954.89l-6.47-2.59a2.21,2.21,0,0,1-1.16-3l4-8,9.21,3.69-2.62,8.53A2.22,2.22,0,0,1,1095,954.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1097.06,946.39l-4.11-1.64c-5.16-2.07-8.37-6.2-6.31-11.37h0c2.07-5.17,9.67-7,14.84-4.92l.64.25c5.17,2.07,9.42,8.63,7.35,13.8h0C1107.4,947.68,1102.23,948.46,1097.06,946.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1119.44,961.52l-.44-.09-5.19-1.74-.45-.11.63-3.26,5.66.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1118.33,963.19l-4.54-.54a1.4,1.4,0,0,1-1.08-1.72l1.28-4.61,5.66.68.13,4.76A1.41,1.41,0,0,1,1118.33,963.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1117.87,958.55l-2.52-.31c-3.17-.37-5.54-2.41-5.11-6h0c.43-3.65,4.42-6.16,7.59-5.79l.39.05c3.18.38,6.47,3.77,6,7.41h0C1123.83,957.5,1121.05,958.92,1117.87,958.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEMON-3",
    "data-name": "LEMON"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.77,942.76c5.47,8.81,12.87,15.12,22.67,15.18l8.84.06c6.2,0,11.19-1.3,15.91-4.57,4.53-3.14,6-11.42,6-17.55,0-14.22-9.61-22.69-22-22.77l-6.88-.05c-9.07-.06-14.45,2.42-18.54,6.45-2.11,2.08-4.09,5.6-6.54,7.34-2.2,1.57-5.09,2.19-5.49,6.37S650.32,937.21,653.77,942.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 691.91,
    cy: 936.16,
    rx: 13.34,
    ry: 18.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M691.21,935.65a.49.49,0,0,1,0,.92l-8.5,3.39a1,1,0,0,1-1.38-.83,21.7,21.7,0,0,1-.09-5.29,1,1,0,0,1,1.38-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M695.79,922.27l-2.46,10a.49.49,0,0,1-.94,0l-3-9.91a1.05,1.05,0,0,1,.7-1.35,8.47,8.47,0,0,1,2.41-.36,8.23,8.23,0,0,1,2.57.41A1,1,0,0,1,695.79,922.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M695.66,950a1,1,0,0,1-.69,1.2,8.26,8.26,0,0,1-2.43.36,8.37,8.37,0,0,1-2.73-.46,1,1,0,0,1-.64-1.36l3.56-9.67a.49.49,0,0,1,.94.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M691,938.72a.49.49,0,0,1,.64.66l-4.4,9a1,1,0,0,1-1.69.24,16.08,16.08,0,0,1-3-5,1,1,0,0,1,.59-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M691.7,933.25a.49.49,0,0,1-.65.64L683,930.26a1.05,1.05,0,0,1-.59-1.33,15.79,15.79,0,0,1,3.44-5.64,1,1,0,0,1,1.69.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M703.93,936.12a23,23,0,0,1-.16,2.65,1,1,0,0,1-1.41.86L695,936.57a.48.48,0,0,1,0-.91l7.42-2.35a1,1,0,0,1,1.42.89C703.9,934.83,703.93,935.47,703.93,936.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M702.74,943.19a16.66,16.66,0,0,1-2.43,4.54,1,1,0,0,1-1.75-.17l-4-8.18a.49.49,0,0,1,.64-.66l6.9,3.15A1.05,1.05,0,0,1,702.74,943.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M702.25,930.66l-7.09,3.22a.49.49,0,0,1-.65-.64l3.81-8.8a1,1,0,0,1,1.75-.24,16.43,16.43,0,0,1,2.77,5.16A1,1,0,0,1,702.25,930.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M954,939.64s-1.68-15.33,14.3-9.06c5.85,2.3,5.42,8.63,10,6.78s15.76-8.51,29.39-2.49c17.26,7.63-8.33,13.54-8.33,13.54s-.18,4.67,11.44.08,15.54,2.19,9.63,6.93c-4.18,3.37,11,1.16,3.25,9.54-4.1,4.44-13.58,5.32-26.38.55-10.72-4-9.36,4.55-22.25,4.31-21.25-.39-21.82-16.88-21.82-16.88S969.66,946.37,954,939.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M935.35,948s-10.2-10.78,3.3-16.19c4.94-2,11.17,3.82,12.45.27s-3.81-6.87,8.18-11.11c15.18-5.37,11.58,5.52,11.58,5.52s3.78,3.1,7.09-5.86,16.73-5.72,16.76.16c0,4.16,12.93-6.21,14.51,2.68s-12,15.86-18.34,18.84A148,148,0,0,1,948,954.57S940.43,953.76,935.35,948Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M965.3,935.49l.27-.08.29-.09L967,935l.22,0c7.11-1.75,13.9-.93,18.25,1.82a18.62,18.62,0,0,1,4.39,5.33h0c0,.08,0,.16.07.24,2.15,7.22-5.26,15.8-16.56,19.17s-22.21.25-24.36-7a9.71,9.71,0,0,1,.18-5.86,18,18,0,0,1,2.73-4.78l.05-.06A28,28,0,0,1,965,935.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 969.28,
    cy: 947.86,
    rx: 18.61,
    ry: 11.31,
    transform: "translate(-230.49 316.59) rotate(-16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M946.66,941l.26-.08.29-.09,1.11-.31.23-.06c7.08-1.82,13.88-1.09,18.27,1.62a18.66,18.66,0,0,1,4.45,5.27h0c0,.08.05.16.07.24,2.24,7.19-5.08,15.86-16.33,19.36s-22.21.51-24.44-6.68a9.59,9.59,0,0,1,.11-5.85,18.19,18.19,0,0,1,2.67-4.82l0-.06a28,28,0,0,1,13-8.46C946.48,941.1,946.57,941.08,946.66,941Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 950.78,
    cy: 953.37,
    rx: 18.61,
    ry: 11.31,
    transform: "translate(-240.2 325.31) rotate(-17.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BASKET_VEGETABLES",
    "data-name": "BASKET & VEGETABLES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CARROT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.19,802.06s12.09-20.07,31.26-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.3,793.41s7.73-.49,6.05,3.33c-1.06,2.41-10.71.84-10.71.84s.33-10.61,4.58-10.52C439.59,787.13,436.3,793.41,436.3,793.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.13,789.32s7.07.78,4.51,3c-1.3,1.16-9.29.21-9.29.21s3.6-9.44,7-9.73S442.13,789.32,442.13,789.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M451.31,786.83s5.51,1.89,3.6,3.71c-.93.88-8.41-2.65-8.41-2.65s3.38-6.09,6.67-5.1C455.34,783.44,451.31,786.83,451.31,786.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M453.78,786.77s12.14-3.3,11.5,1.76C464.8,792.35,453.78,786.77,453.78,786.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.92,811.91s2.09-23-17.35-28.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.91,794.47s-6.29-3.16-5.54.08c.38,1.64,7.52,5.16,7.52,5.16s2.7-9.71.05-11.79S423.91,794.47,423.91,794.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417.85,787.49s-5.67-1.42-5.19,1.11c.23,1.23,8.5,2.34,8.5,2.34s.88-6.83-2.42-7.78C416.57,782.52,417.85,787.49,417.85,787.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.85,786.1s-8-9.24-10.53-4.73C403.43,784.77,415.85,786.1,415.85,786.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.81,800.89s11.77-21.84-3.44-34.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.88,781.53s-3.7-4.87-4.48-1.64c-.4,1.64,4.48,7.69,4.48,7.69s6.66-6.53,4.36-10.94C432.71,773.73,429.88,781.53,429.88,781.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.11,773.29s-4.5-3.56-5.2-1.08c-.35,1.2,6.64,5.54,6.64,5.54s3.88-5.82,1.32-8C429.19,768.29,428.11,773.29,428.11,773.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.92,771.24s-3.09-11.58-7.4-8.51C416.27,765,426.92,771.24,426.92,771.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M386.56,925.49h0a4.55,4.55,0,0,1-3.3-5.35l26.14-111c1.62-6.59,8.81-10.5,15.66-8.51l3.47,1c6.85,2,10.5,9,7.93,15.35l-44,105.8A4.9,4.9,0,0,1,386.56,925.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.1,831.26s16-17.55,33.53-8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.84,824s7.69.89,5.26,4.34c-1.53,2.18-10.68-1.07-10.68-1.07s2.48-10.36,6.64-9.52C460.35,818.45,455.84,824,455.84,824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462.4,821.05s6.78,2,3.8,3.8c-1.51.89-9.16-1.45-9.16-1.45s5.47-8.63,8.89-8.31S462.4,821.05,462.4,821.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.91,820.24s5,2.83,2.78,4.28c-1.09.7-7.71-4.09-7.71-4.09s4.56-5.38,7.58-3.83C476.56,817.62,471.91,820.24,471.91,820.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.6,819.83s12.59-1.08,10.93,3.77C481.28,827.27,471.6,819.83,471.6,819.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.86,840.53s6.75-22.23-11.25-30.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.46,822.87s-5.53-4.21-5.45-.9c0,1.69,6.33,6.41,6.33,6.41s4.63-9.06,2.45-11.57S443.46,822.87,443.46,822.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M438.94,815s-5.28-2.4-5.32.17c0,1.24,7.87,3.81,7.87,3.81s2.25-6.55-.79-8.08C438.69,809.85,438.94,815,438.94,815Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.26,813.23s-6-10.49-9.37-6.51C425.34,809.73,437.26,813.23,437.26,813.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444,829.52s16-19.36,3.65-34.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452,811.23s-2.64-5.44-4.07-2.41c-.73,1.55,2.83,8.35,2.83,8.35s7.87-5.23,6.51-10C456.34,804.07,452,811.23,452,811.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M451.91,802.83s-3.69-4.29-4.89-2c-.58,1.12,5.4,6.61,5.4,6.61s5-5,2.93-7.63C454,798.11,451.91,802.83,451.91,802.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M451.16,800.6s-.67-11.91-5.53-9.66C442,792.63,451.16,800.6,451.16,800.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M380.06,944.89h0a4.42,4.42,0,0,1-2.15-5.83l48.31-104.33c2.93-6.18,10.79-8.74,17.11-5.58l3.2,1.61a11.32,11.32,0,0,1,4.66,16.48l-64.8,96.07A5,5,0,0,1,380.06,944.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.48,831.12s6.52-17.34,24.46-15.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390,823.38s6.64-1.51,5.94,1.71c-.44,2-9.17,2.2-9.17,2.2s-1.84-8.29,1.88-8.84C391.56,818,390,823.38,390,823.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.21,819.35s6.33-.41,4.55,1.72c-.91,1.08-8.07,1.5-8.07,1.5s1.26-7.86,4.19-8.58S394.21,819.35,394.21,819.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.72,816.09s5.19.67,3.88,2.36c-.63.83-7.86-.84-7.86-.84s1.73-5.22,4.79-4.93C404.55,812.87,401.72,816.09,401.72,816.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.86,815.69s9.94-4.32,10.39-.29C414.6,818.43,403.86,815.69,403.86,815.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.47,839.1s-2.79-18.19-20.8-19.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.35,826s-6.12-1.54-4.81.87c.66,1.22,7.59,2.93,7.59,2.93s.41-7.94-2.32-9.18S379.35,826,379.35,826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.66,821.43s-5.22-.28-4.3,1.62c.45.92,7.89.59,7.89.59s-.6-5.43-3.67-5.7C370.55,817.76,372.66,821.43,372.66,821.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.64,820.65s-8.84-6-10.13-2.16C359.54,821.41,370.64,820.65,370.64,820.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.29,830.7s5.9-18.68-9.89-26.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382,815.07s-4.21-3.26-4.24-.63c0,1.33,5.45,5.33,5.45,5.33s4.5-6,1.61-9.13C382.87,808.59,382,815.07,382,815.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.77,808.92s-4.63-2.11-4.75-.09c-.06,1,6.91,3.34,6.91,3.34s2.21-5.08-.46-6.41C378.71,804.88,378.77,808.92,378.77,808.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.32,807.5s-5-8.56-8.15-5.55C366.8,804.22,377.32,807.5,377.32,807.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M377.93,945.36h0c-2.51-.08-4.54-1.76-4.65-3.86l-5.44-100.38c-.26-6,5.59-10.84,12.75-10.61l3.61.12c7.16.23,12.62,5.48,11.89,11.42l-13.22,99.76C382.59,943.9,380.44,945.44,377.93,945.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ONION-2",
    "data-name": "ONION"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.94,934.26l-3.33,1.62c-21.93-43.31-39.5-123.39-39.68-124.19l3.64-.75C244.75,811.74,262.23,891.37,283.94,934.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.55,933.54l-3.11,2c-9.36-14-22.51-40.42-31.95-86.45a435.93,435.93,0,0,1-7.32-49.47l3.71-.25a435.77,435.77,0,0,0,7.27,49.06C264.3,873.5,273.92,908.62,290.55,933.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.61,935.71l-3.61.91c-.05-.18-4.91-18.32-16.3-42.62-10.48-22.39-28.81-54.74-56.55-81.71l2.61-2.59c28.17,27.38,46.74,60.17,57.36,82.86C276.63,917.14,281.56,935.53,281.61,935.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "285.81 931.06 282.39 932.5 222.27 796.48 225.68 795.03 285.81 931.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278,936.51s-4.37-14.66-10.67-29.72c0,0,2.47-5.3,7.87-3.45a197.55,197.55,0,0,0,15.45,30.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 284.4,
    cy: 935.44,
    rx: 6.5,
    ry: 3.8,
    transform: "translate(-146.35 57.73) rotate(-9.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.61,935.14l-3.16,1.91c-21.58-50.61-39.55-144.33-39.73-145.27l3.46-.9C275.36,791.82,293.23,885,314.61,935.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.91,934.27,318,936.62c-9.15-16.39-22.1-47.23-31.8-101.1-5.79-32.13-7.7-57.66-7.72-57.92l3.54-.31c0,.25,1.92,25.54,7.67,57.44C295,864.07,304.66,905.16,320.91,934.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.4,936.85,309,937.94a388,388,0,0,0-16.2-49.85c-10.35-26.17-28.33-64-55.22-95.42l2.46-3c27.3,31.93,45.53,70.25,56,96.77A393.08,393.08,0,0,1,312.4,936.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "316.34 931.38 313.1 933.09 246.91 757.81 250.15 756.1 316.34 931.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.23,939s-4.68-18.3-10.92-35.91c0,0,2.27-6.21,7.46-4.08A259.06,259.06,0,0,0,321,934.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.47,932.11c3.35-.78,6.33.57,6.66,3s-2.11,5-5.46,5.82-6.33-.57-6.66-3S311.13,932.88,314.47,932.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "299.51 922.02 289.41 920.56 228.5 748.45 231.74 746.74 299.51 922.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.93,929.09s-4.79-17.8-11-35.4c0,0,2.14-5.73,7.33-3.6a279.63,279.63,0,0,0,15.33,34.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.37,923.64c3.32-.86,6.13,0,6.27,1.83s-2.44,4.08-5.77,4.93-5.92,0-6.07-1.87S293,924.49,296.37,923.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MUSHROOMS-2",
    "data-name": "MUSHROOMS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.88,915.85l7.34-4.18a2.69,2.69,0,0,1,3.77,1.21l4.56,9.81-10.46,5.95-6.1-8.93A2.69,2.69,0,0,1,341.88,915.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.4,924.2l4.66-2.65c5.86-3.34,12.2-3.26,15.53,2.61h0c3.34,5.86-.68,14.43-6.54,17.77l-.73.41c-5.86,3.33-15.28,2.4-18.62-3.46h0C339.37,933,342.54,927.53,348.4,924.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.68,923.84l-6.84.11a2.17,2.17,0,0,1-2.21-2.33l.59-8.74,9.74-.15.86,8.72A2.18,2.18,0,0,1,332.68,923.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.3,915.37l-4.34.07c-5.47.08-9.94-2.44-10-7.91h0c-.09-5.46,6.11-10,11.57-10.08h.68c5.46-.08,11.8,4.25,11.88,9.72h0C341.15,912.62,336.76,915.29,331.3,915.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.39,902.9l-5.84,3.57a2.18,2.18,0,0,1-3.08-.89l-3.94-7.83,8.32-5.08,5.17,7.09A2.17,2.17,0,0,1,363.39,902.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.9,896.3l-3.7,2.27c-4.67,2.84-9.81,2.93-12.65-1.73h0c-2.85-4.67.19-11.71,4.86-14.56l.57-.35c4.67-2.85,12.33-2.33,15.17,2.34h0C365,888.93,362.57,893.46,357.9,896.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303,859.4l-3.86-2.93a1.55,1.55,0,0,1-.22-2.26l4.15-4.62,5.5,4.17L305.19,859A1.54,1.54,0,0,1,303,859.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.89,854.07l-2.45-1.86c-3.08-2.34-4.47-5.7-2.13-8.78h0c2.34-3.08,7.77-2.9,10.85-.56l.38.29c3.08,2.34,4.72,7.52,2.38,10.6h0C312.58,856.84,309,856.41,305.89,854.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.68,895.24l-7.66-6a3,3,0,0,1-.51-4.35l7.89-8.45L325.31,885,319,894.68A3,3,0,0,1,314.68,895.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.17,885.32l-4.86-3.79c-6.11-4.78-9-11.35-4.53-17h0c4.43-5.68,15-4.81,21.16,0l.75.59c6.11,4.78,9.53,14.86,5.1,20.54h0C333.35,891.27,326.29,890.09,320.17,885.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.68,870.58l-8.76,2.19a2.87,2.87,0,0,1-3.53-2.32L342.52,859,355,855.93l3.71,10.94A2.87,2.87,0,0,1,356.68,870.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.37,860.12l-5.56,1.39c-7,1.74-13.49-.16-15.24-7.15h0c-1.74-7,4.86-14.67,11.85-16.41l.86-.22c7-1.74,16.43,1.92,18.17,8.92h0C364.2,853.64,359.36,858.37,352.37,860.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BASKET"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.11,946.62H299C277,946.62,258,933,253.42,914l-14.74-61.61H448.45L433.72,914C429.17,933,410.14,946.62,388.11,946.62Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 273.12,
    y1: 939.69,
    x2: 256.54,
    y2: 852.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.73,946.61a62.48,62.48,0,0,1-2.72-9.9l-15.82-84.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.48,946.89a61.07,61.07,0,0,1-2.82-10.18l-15.83-84.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.07,946.76a61.71,61.71,0,0,1-2.77-10l-15.83-84.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.73,946.81a62.34,62.34,0,0,1-2.79-10.1l-15.82-84.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.41,946.85a60.78,60.78,0,0,1-2.83-10.14l-15.82-84.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.93,946.56a61.55,61.55,0,0,1-2.7-9.85L368.4,852.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.72,944.07a60.93,60.93,0,0,1-1.85-7.36l-15.82-84.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 421.14,
    y1: 934.84,
    x2: 405.69,
    y2: 852.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 434.14,
    y1: 912.54,
    x2: 424.33,
    y2: 852.34
  }))), /*#__PURE__*/React.createElement("g", {
    id: "COOK_S_RIGHT_HAND",
    "data-name": "COOK'S RIGHT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HAND-2",
    "data-name": "HAND",
    className: "cls-10",
    d: "M1163.62,697.66c.4,19-13.63,147.64-33.31,165.12-20.12,17.88-107.42,30-176.88,36.09,0,0,5.89-27.34-20.42-31.86,0,0,95.36-44.49,120.58-46.84,0,0,21-106.74,34.38-130.81C1108.8,652,1162.53,644.63,1163.62,697.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LINES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M975.2,846.6c28.81-11.16,69-25.13,82.93-26.43,0,0,10.64-92.75,24.07-116.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1170.57,696.77c1.87,60.1-21.42,154.31-47.84,173.66-8.13,6-139,26.29-147.7,26.91"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ARM-2",
    "data-name": "ARM",
    className: "cls-5",
    d: "M953.32,898.3c-4.76,4.35-29.49,20.75-42.14,23.08-8,1.47-22.56-3.69-24.36-4.78s-12-14.66-12-14.66,5.91-5.86,12.46-.32c8.41,7.12,16.51,3.53,21.78-.89,2.19-1.84,4.8-6.85,1.8-9.4s-10.91,4.22-14.17,4.47c-6.62.51-8.56-2.68-8.56-2.68s13.36-13,16-14.92,18.39-11.19,32.44-11C947.8,867.37,964.36,888.22,953.32,898.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CUFF-2",
    "data-name": "CUFF",
    className: "cls-3",
    d: "M933,867l17.65-8s22.81,8.27,24.37,39.58l-21.6.33S950,874.53,933,867Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAMP"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1008.33,
    cy: 370.66,
    r: 29.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1008.73,
    y1: 195.27,
    x2: 1008.73,
    y2: 326.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1102.8,365.11H914.66l54.42-28.76a84.83,84.83,0,0,1,39.65-9.83h0a84.76,84.76,0,0,1,39.64,9.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SHELVES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BUTTOM_SHELF",
    "data-name": "BUTTOM SHELF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JARS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.87,434.79v2.94a2.59,2.59,0,0,1-1.8,2.46v1.08a2.59,2.59,0,0,1-2.59,2.59H334.12a2.58,2.58,0,0,1-2.59-2.59v-1.08a2.58,2.58,0,0,1-1.8-2.46v-2.94a2.59,2.59,0,0,1,2.59-2.59h26A2.59,2.59,0,0,1,360.87,434.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.41,439.53h27.78a16,16,0,0,1,16,16v58.9a7.67,7.67,0,0,1-7.67,7.67H323a7.67,7.67,0,0,1-7.67-7.67v-58.9A16,16,0,0,1,331.41,439.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.9,487.52V510.4a7.47,7.47,0,0,1-7.46,7.47H327.16a7.47,7.47,0,0,1-7.46-7.47V487.52c0-2.26,11.46-6.43,25.6-6.43S370.9,485.26,370.9,487.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.13,434.79v2.94a2.59,2.59,0,0,1-1.79,2.46v1.08a2.6,2.6,0,0,1-2.59,2.59H408.38a2.58,2.58,0,0,1-2.59-2.59v-1.08a2.58,2.58,0,0,1-1.8-2.46v-2.94a2.59,2.59,0,0,1,2.59-2.59h26A2.59,2.59,0,0,1,435.13,434.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.67,439.53h27.78a16,16,0,0,1,16,16v58.9a7.67,7.67,0,0,1-7.67,7.67H397.3a7.67,7.67,0,0,1-7.67-7.67v-58.9A16,16,0,0,1,405.67,439.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.16,484.83v23c0,5.54-3.34,10-7.46,10H401.43c-4.13,0-7.47-4.5-7.47-10V480.94c0-5.63,10.8-13.76,30.73-9.06C441.54,475.86,445.16,484.83,445.16,484.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SPICE-2",
    "data-name": "SPICE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.82,488.26h8.11A10.06,10.06,0,0,1,504,498.32v14.34a7.91,7.91,0,0,1-7.91,7.91H483.67a7.91,7.91,0,0,1-7.91-7.91V498.32A10.06,10.06,0,0,1,485.82,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M486.26,488.26H495a9.74,9.74,0,0,1,9.74,9.74v14.42a8.15,8.15,0,0,1-8.15,8.15H484.67a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,486.26,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M477.71,488.26h8.75A9.74,9.74,0,0,1,496.2,498v14.42a8.15,8.15,0,0,1-8.15,8.15H476.12a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,477.71,488.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 472.88,
    y: 498.56,
    width: 18.1,
    height: 11.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M491.44,475.46h-5.09c-3.92,0-6.6,4.26-5.16,8.18l1.68,4.59h12.05l1.68-4.59C498,479.72,495.35,475.46,491.44,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.93,475.46h-5.09c-3.92,0-6.6,4.26-5.16,8.18l1.68,4.59h12.05l1.68-4.59C492.53,479.72,489.84,475.46,485.93,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.91,488.26H541a10.06,10.06,0,0,1,10.06,10.06v14.34a7.91,7.91,0,0,1-7.91,7.91H530.76a7.91,7.91,0,0,1-7.91-7.91V498.32A10.06,10.06,0,0,1,532.91,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M533.36,488.26h8.75a9.74,9.74,0,0,1,9.74,9.74v14.42a8.15,8.15,0,0,1-8.15,8.15H531.76a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,533.36,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M524.8,488.26h8.75A9.74,9.74,0,0,1,543.3,498v14.42a8.15,8.15,0,0,1-8.15,8.15H523.21a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,524.8,488.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 519.97,
    y: 498.56,
    width: 18.1,
    height: 11.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.92,475.46h-4.69c-3.92,0-6.6,4.26-5.16,8.18l1.68,4.59H542.4l1.68-4.59C545.52,479.72,542.84,475.46,538.92,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.63,475.46h-4.7c-3.92,0-6.6,4.26-5.16,8.18l1.68,4.59h11.66l1.68-4.59C539.23,479.72,536.54,475.46,532.63,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M580,488.26h8.11a10.06,10.06,0,0,1,10.06,10.06v14.34a7.91,7.91,0,0,1-7.91,7.91H577.85a7.91,7.91,0,0,1-7.91-7.91V498.32A10.06,10.06,0,0,1,580,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M580.45,488.26h8.75a9.74,9.74,0,0,1,9.74,9.74v14.42a8.15,8.15,0,0,1-8.15,8.15H578.85a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,580.45,488.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.9,488.26h8.75a9.74,9.74,0,0,1,9.74,9.74v14.42a8.15,8.15,0,0,1-8.15,8.15H570.3a8.15,8.15,0,0,1-8.15-8.15V498A9.74,9.74,0,0,1,571.9,488.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 567.07,
    y: 498.56,
    width: 18.1,
    height: 11.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.62,475.46h-5.87c-3.92,0-6.61,4.26-5.17,8.18l1.69,4.59H589.1l1.68-4.59C592.22,479.72,589.54,475.46,585.62,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M579.32,475.46H575c-3.91,0-6.6,4.26-5.16,8.18l1.68,4.59H582.8l1.69-4.59C585.92,479.72,583.24,475.46,579.32,475.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SAUCES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M681.69,439.32H679.8a2.26,2.26,0,0,1,.24,1v1.73a1.57,1.57,0,0,1-1.57,1.57h-9.55a1.57,1.57,0,0,1-1.58-1.57v-1.73a2.4,2.4,0,0,1,.24-1h-2V436a2.32,2.32,0,0,1,2.32-2.32h11.44a2.32,2.32,0,0,1,2.32,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689.24,483.81l-2,29.09a4.84,4.84,0,0,1-4.76,4.57H664.8a4.83,4.83,0,0,1-4.75-4.57l-2-29.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M692.83,475.46,690,515.63A5.73,5.73,0,0,1,684.3,521H663a5.73,5.73,0,0,1-5.72-5.33l-2.81-40.17a9.33,9.33,0,0,1,3.9-8.27,10.76,10.76,0,0,0,4.62-8.81l-.13-15.1a3.8,3.8,0,0,1,3.79-4h14a3.79,3.79,0,0,1,3.79,4l-.13,15.1a10.78,10.78,0,0,0,4.62,8.8A9.36,9.36,0,0,1,692.83,475.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M683.49,499.84c-.3,1.67-4.61,3.78-9.87,3.78s-9.57-2.11-9.87-3.78l0-21.15c.54-1.6,4.74-3.62,9.83-3.62s9.29,2,9.83,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.13,444.44v1a2.15,2.15,0,0,1-2.15,2.15h0v3.27a2.23,2.23,0,0,1-2.23,2.24h-4.31a2.23,2.23,0,0,1-2.23-2.24v-3.27h0a2.15,2.15,0,0,1-2.15-2.15v-1a2.15,2.15,0,0,1,2.15-2.15H733A2.15,2.15,0,0,1,735.13,444.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.68,500.06c0,4.64-2.81,11.7-5.37,15.86a3.26,3.26,0,0,1-2.77,1.54H720.32a3.25,3.25,0,0,1-2.79-1.57c-2.56-4.28-5.37-11.85-5.37-16.49a25.16,25.16,0,0,1,1.3-8.24h31.75A26.08,26.08,0,0,1,746.68,500.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M749.93,499.89c0,5.52-3.34,13.91-6.39,18.85a3.84,3.84,0,0,1-3.28,1.83H718.61a3.86,3.86,0,0,1-3.31-1.87c-3-5.09-6.38-14.07-6.38-19.58,0-11.06,5-19.27,13.61-22.6V454.76l-4.66-7.14h18.44v28.9C744.91,479.84,749.93,488.84,749.93,499.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.31,453.13h6.16a6,6,0,0,1,5.68,8.11l-6.64,18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.61,465.94v52.49a2.53,2.53,0,0,1-2.53,2.53h-20a2.53,2.53,0,0,1-2.53-2.53V465.94a7.58,7.58,0,0,1,6.14-7.45V446h12.78v12.52A7.58,7.58,0,0,1,641.61,465.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M637.93,473.49V515a2.6,2.6,0,0,1-2.41,2.75H622.64a2.6,2.6,0,0,1-2.42-2.75V473.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 619.83,
    y: 444.01,
    width: 18.49,
    height: 4.06,
    rx: 1.17
  })), /*#__PURE__*/React.createElement("g", {
    id: "SHELF"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "308.37 546.73 281.83 546.73 281.83 559.96 308.37 555.88 308.37 546.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.97,
    y1: 587.88,
    x2: 747.58,
    y2: 587.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.14,
    y: 522.52,
    width: 534.07,
    height: 24.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 281.84,
    y: 546.73,
    width: 26.53,
    height: 41.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "774.92 546.73 748.38 546.73 748.38 559.96 774.92 555.88 774.92 546.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 748.38,
    y: 546.73,
    width: 26.53,
    height: 41.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "KNIVES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.08,622.06v47.32c0,17.29,4.5,29.53,13.17,45.06h0s15.09-44.48,16.19-86.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.25,624.47l-13.17-2.41V578c0-3.19,2.94-5.77,6.58-5.77h0c3.64,0,6.59,2.58,6.59,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.73,622.06H411.42v92.38S428.73,683.69,428.73,622.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.59,622.06H411.42V578c0-3.19,2.95-5.77,6.59-5.77h0c3.64,0,6.58,2.58,6.58,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476,627.35a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.87.87,0,0,1,0,1.32v0a2.19,2.19,0,0,0-.72,1.63,2.22,2.22,0,0,0,.74,1.65.87.87,0,0,1,0,1.32v0a2.19,2.19,0,0,0-.72,1.63,2.23,2.23,0,0,0,.74,1.65.87.87,0,0,1,0,1.32v0a2.19,2.19,0,0,0-.72,1.63,2.23,2.23,0,0,0,.74,1.65.88.88,0,0,1,0,1.32l0,0a2.2,2.2,0,0,0,0,3.27.88.88,0,0,1,0,1.33h0a2.22,2.22,0,0,0,0,3.29.87.87,0,0,1,0,1.32h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33h0a2.8,2.8,0,0,0-.72,1.63c0,.5,0,2.31,1.36,2.31h-.63c-11.21,0-20.3-8-20.3-17.78v-74.6h20.93c-.68,0-.19.25-.64.67a2.21,2.21,0,0,0,0,3.28.88.88,0,0,1,0,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M468.92,622.06H455.75V578c0-3.19,2.94-5.77,6.58-5.77h0c3.64,0,6.59,2.58,6.59,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.65,650.45a108.45,108.45,0,0,1-4.12,28.19H503.37a3.06,3.06,0,0,1-3.28-3.46,116.26,116.26,0,0,0,2.5-24.73,110.5,110.5,0,0,0-3.4-28.39h35.29A108.68,108.68,0,0,1,538.65,650.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.29,622.06H499.12V578c0-3.19,2.95-5.77,6.59-5.77h0c3.64,0,6.58,2.58,6.58,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M580.61,621.66c-.49,32.21-15.63,55.76-15.63,55.76V621.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M575.12,621.66H565V577.55a5.22,5.22,0,0,1,5.07-5.36h0a5.22,5.22,0,0,1,5.07,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641,638.79v0a2.77,2.77,0,0,1-2.79,2.74h-.38a22.41,22.41,0,0,0,.18-2.86c0-11.13-8-20.16-17.82-20.16s-17.83,9-17.83,20.16a22.41,22.41,0,0,0,.18,2.86h-.39a2.77,2.77,0,0,1-2.78-2.75v0c0-8.88,4.34-16.6,10.74-20.62a11.34,11.34,0,0,0,5.4-9.6V577.21a4.86,4.86,0,0,1,4.67-5,4.48,4.48,0,0,1,3.3,1.47,5.19,5.19,0,0,1,1.37,3.55v31.36a11.37,11.37,0,0,0,5.4,9.6C636.65,622.19,641,629.91,641,638.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M634.37,636.9H606a3.66,3.66,0,0,0-3.66,3.67v3.27A3.66,3.66,0,0,0,606,647.5h28.39a3.66,3.66,0,0,0,3.66-3.66v-3.27A3.66,3.66,0,0,0,634.37,636.9Zm.46,7.28H605.51v-3.81h29.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689.56,618.93H679.42V577.26a5.07,5.07,0,0,1,5.07-5.07h0a5.07,5.07,0,0,1,5.07,5.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 684.49,
    cy: 642.83,
    r: 19.29,
    transform: "translate(-254.06 672.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 684.49,
    cy: 642.85,
    r: 3.72,
    transform: "translate(-98.8 1160.77) rotate(-76.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M663.08,631.73a24.12,24.12,0,0,1,42.83,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 684.49,
    y1: 618.71,
    x2: 684.49,
    y2: 642.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TOP_SHELF",
    "data-name": "TOP SHELF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHELF-2",
    "data-name": "SHELF"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "306.07 389.83 280.61 389.83 280.61 403.06 306.07 398.97 306.07 389.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.14,
    y: 365.61,
    width: 534.07,
    height: 24.22,
    transform: "translate(1056.35 755.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 749.89,
    y: 389.83,
    width: 25.46,
    height: 41.15,
    transform: "translate(1525.24 820.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "775.35 389.83 749.89 389.83 749.89 403.06 775.35 398.97 775.35 389.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 280.61,
    y: 389.83,
    width: 25.46,
    height: 41.15,
    transform: "translate(586.68 820.8) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SCOOP",
    className: "cls-2",
    d: "M775.18,288.41a1.6,1.6,0,0,1-1.61,1.61H729.52v10.37a9.44,9.44,0,0,1-9.44,9.44h-4.34a9.43,9.43,0,0,1-9.44-9.44V286.8h67.27A1.62,1.62,0,0,1,775.18,288.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "GRATER"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "674.69 365.49 662.64 365.49 650.98 282.34 663.03 282.34 674.69 365.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "662.64 365.49 606.03 365.49 617.7 282.34 650.98 282.34 662.64 365.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 623.94,
    y: 292.35,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 632.1,
    y: 292.35,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 640.27,
    y: 292.35,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 620.05,
    y: 305.56,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 628.21,
    y: 305.56,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 636.38,
    y: 305.56,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 644.54,
    y: 305.56,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 620.05,
    y: 318.76,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 628.21,
    y: 318.76,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 636.38,
    y: 318.76,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 644.54,
    y: 318.76,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 616.16,
    y: 331.97,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 624.33,
    y: 331.97,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 632.49,
    y: 331.97,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 640.66,
    y: 331.97,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 648.82,
    y: 331.97,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 616.16,
    y: 345.17,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 624.33,
    y: 345.17,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 632.49,
    y: 345.17,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 640.66,
    y: 345.17,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 648.82,
    y: 345.17,
    width: 3.56,
    height: 7.16,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648,267.32H632.72a15,15,0,0,0-15,15H663A15,15,0,0,0,648,267.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M632.33,267.32h4A14.63,14.63,0,0,1,651,281.95v.4a0,0,0,0,1,0,0H617.7a0,0,0,0,1,0,0v-.4A14.63,14.63,0,0,1,632.33,267.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BEAKER"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749,294.62v65.11a5.75,5.75,0,0,1-5.75,5.76H707.44a5.75,5.75,0,0,1-5.75-5.76V325.79a63.62,63.62,0,0,0-8.17-31.17Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 307.04,
    x2: 742.23,
    y2: 307.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 322.73,
    x2: 742.23,
    y2: 322.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 314.88,
    x2: 735.49,
    y2: 314.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 330.57,
    x2: 735.49,
    y2: 330.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 338.41,
    x2: 742.23,
    y2: 338.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 354.09,
    x2: 742.23,
    y2: 354.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 748.97,
    y1: 346.25,
    x2: 735.49,
    y2: 346.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "POTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352,219.86h84a0,0,0,0,1,0,0V262a16.73,16.73,0,0,1-16.73,16.73H368.71A16.73,16.73,0,0,1,352,262v-42.1A0,0,0,0,1,352,219.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436,219.86h13.67a4.58,4.58,0,0,1,4.58,4.58v.63a4.58,4.58,0,0,1-4.58,4.58H436a0,0,0,0,1,0,0v-9.79A0,0,0,0,1,436,219.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.74,219.86H347.4a4.58,4.58,0,0,1,4.58,4.58v.63a4.58,4.58,0,0,1-4.58,4.58H333.74a0,0,0,0,1,0,0v-9.79A0,0,0,0,1,333.74,219.86Z",
    transform: "translate(685.72 449.52) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.24,240.5H450.72a0,0,0,0,1,0,0v62.75A16.73,16.73,0,0,1,434,320H354a16.73,16.73,0,0,1-16.73-16.73V240.5A0,0,0,0,1,337.24,240.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M450.72,240.5h18.46a6.19,6.19,0,0,1,6.19,6.19v.85a6.19,6.19,0,0,1-6.19,6.19H450.72a0,0,0,0,1,0,0V240.5A0,0,0,0,1,450.72,240.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.59,240.5h18.46a6.19,6.19,0,0,1,6.19,6.19v.85a6.19,6.19,0,0,1-6.19,6.19H312.59a0,0,0,0,1,0,0V240.5a0,0,0,0,1,0,0Z",
    transform: "translate(649.83 494.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449,365.22H339a16.73,16.73,0,0,1-16.73-16.72V264.8H465.67v83.7A16.73,16.73,0,0,1,449,365.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M490.73,281.52H465.67V269.33h25.06a6.1,6.1,0,0,1,6.09,6.1h0A6.09,6.09,0,0,1,490.73,281.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.23,281.52h25.06V269.33H297.23a6.1,6.1,0,0,0-6.09,6.1h0A6.09,6.09,0,0,0,297.23,281.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.62,
    y: 262.55,
    width: 150.65,
    height: 6.79,
    rx: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436,219.86H352c4.07-7.82,21.33-13.7,42-13.7S431.91,212,436,219.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402,196.33h-16.1a2.21,2.21,0,0,0-2.05,3l2.85,7.22h14.5l2.85-7.22A2.2,2.2,0,0,0,402,196.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POT-2",
    "data-name": "POT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M567.68,301.65V360.3c0,2.87-3,5.19-6.69,5.19H519.36c-3.7,0-6.69-2.32-6.69-5.19V329.73a47.67,47.67,0,0,0-9.5-28.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M590.72,305v28.54h0a5,5,0,0,1-5-5.05V310.25a3.39,3.39,0,0,0-3.39-3.39h-14.6v-5.21h19.65A3.38,3.38,0,0,1,590.72,305Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1016.19,
    cy: 606.92,
    r: 10.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1009.38,610.32s3.16-9.23,9.64-8.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1013.84,
    y1: 606.22,
    x2: 1017.45,
    y2: 608.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "959.11 611.4 953.9 629.8 964.89 635.54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 975.49,
    cy: 610.32,
    rx: 3.08,
    ry: 3.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 946.31,
    cy: 615.81,
    rx: 3.08,
    ry: 3.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M962.76,647.81A16.83,16.83,0,0,0,983.37,637"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.f54e9744f38503380a8f09b0c42acad3.svg";
export { ForwardRef as ReactComponent };